<!--
・このコンポーネントは、外部サイトにPOSTで遷移するために利用します。
・サイト内での遷移には利用しないでください。
-->
<template>
  <form name="_externalForm" :action="action" method="POST" :target="target">
    <input v-for="param in mergeParams"
      :key="param.name"
      :name="param.name"
      :value="param.value" />
  </form>
</template>

<script>
export default {
  props: {
    target: {
      type: String,
      required: '_self'
    }
  },
  data: () => ({
    action: null,
    baseParams: [],
    params: []
  }),
  computed: {
    mergeParams () {
      return this.baseParams.concat(this.params)
    }
  },
  methods: {
    initBaseParams () {
      // 共通のパラメータを設定
      this.baseParams.push({
        name: 'auth_token',
        value: this.$store.state.auth.token
      })
    },
    // `submit`イベントを実行
    doSubmit (action, params = []) {
      // 親コンポーネントから呼び出されるメソッド
      // 例：HTML
      //     <mp-external-form ref="externalForm" ...></mp-external-form>
      //     js
      //     this.$refs.externalForm.doSubmit('url or path')
      // 例：params の設定値
      //     ※nameの重複は考慮していないため、将来的に重複ある場合は設定する側かマージする際に変更が必要
      // [
      //   {
      //     name: 'xxx',
      //     value: 'yyy'
      //   },
      //   ....
      // ]

      // パラメータの設定
      this.initBaseParams()

      this.action = action
      this.params = params
      // レンダリング後にsubmit実行
      this.$nextTick()
        .then(() => this.$el.submit())
    },
    doSubmitNoToken (action, params = []) {
      // パラメータの設定
      this.action = action
      this.params = params
      // レンダリング後にsubmit実行
      this.$nextTick()
        .then(() => this.$el.submit())
    }
  },
  created: function () {}
}
</script>

<style scoped>
form {
  display: none;
}
</style>
